import React, { Component } from 'react';
import update from 'react-addons-update';
import quizQuestions from './data/quizQuestions';
import Quiz from './components/Quiz';
import Result from './components/Result';
import ggylogo from './svg/ggylogo.png';
import './App.css';
var uuid = require('uuid');

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      id:uuid.v1(),
      name: '',
      email: '',
      consent: true,
      counter: 0,
      questionId: 1,
      question: '',
      answerOptions: [],
      answer: '',
      answersCount: {
        Administration: 0,
        Apostleship: 0,
        'Artistic Expression': 0,
        Craftsmanship: 0,
        Discernment: 0,
        Evangelism: 0,
        Exhortation: 0,
        Faith: 0,
        Giving: 0,
        Helps: 0,
        Hospitality: 0,
        Intercession: 0,
        Knowledge: 0,
        Leadership: 0,
        Mercy: 0,
        Prophecy: 0,
        Shepherding: 0,
        Teaching: 0,
        Wisdom: 0,
        Healing: 0,
        'Miraculous Powers': 0,
        Tongues: 0,
        'Interpretation of Tongues': 0
      },
      results: []
    };

    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const shuffledAnswerOptions = quizQuestions.map((question) => this.shuffleArray(question.answers));
    this.setState({
      question: quizQuestions[0].question,
      answerOptions: shuffledAnswerOptions[0]
    });
  }

  shuffleArray(array) {
    //TODO: get rid of this shuffling
    return array;
  };

  handleAnswerSelected(event) {
    this.setUserAnswer(event.currentTarget.value);

    if (this.state.questionId < quizQuestions.length) {
        setTimeout(() => this.setNextQuestion(), 300);
    } else {
        setTimeout(() => this.setResults(this.getResults()), 300);
    }
  }

  handleSubmit(event) {
    this.setState({
        name: this.refs.name.value,
        email: this.refs.email.value
    });
    event.preventDefault();
  }

  setUserAnswer(answer) {
    const answerParts = answer.split('|');
    const type = answerParts[0];
    const value = Number(answerParts[1]);
    const updatedAnswersCount = update(this.state.answersCount, {
      [type]: {$apply: (currentValue) => currentValue + value}
    });

    this.setState({
        answersCount: updatedAnswersCount,
        answer: answer
    });
  }

  setNextQuestion() {
    const counter = this.state.counter + 1;
    const questionId = this.state.questionId + 1;

    this.setState({
        counter: counter,
        questionId: questionId,
        question: quizQuestions[counter].question,
        answerOptions: quizQuestions[counter].answers,
        answer: ''
    });
  }

  getResults() {
    const answersCount = this.state.answersCount;
    const answersCountKeys = Object.keys(answersCount);
    answersCountKeys.sort(function(a, b) { return answersCount[b] - answersCount[a] });
    const sortedResults = answersCountKeys.map(gift => gift + ": " + answersCount[gift]);
    return sortedResults;

  }

  setResults(results) {
    this.setState({ results: results });

    fetch('/api/survey', {
      method: 'post',
      headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: this.state.name,
        email: this.state.email,
        consent: this.state.consent,
        results: this.state.results
      })
  });
  }

  renderLogin() {
    return (
      <div className="welcome-page">
        <p>Welcome to the GodGiftsYou Spiritual Gifts Assessment!  We
          hope it will be helpful as you seek to discover more of how God has uniquely
          designed you.</p>
        <p>You'll notice that once you answer a question, you are automatically
          presented with the next one with no opportunity to change your answer.  This
          is deliberate, as we believe it's better not to overthink your answers.  Just
          go with your first intuition.</p>
        <p>We value your privacy,
          and will never sell your email address or share it.  
          You will receive an
          email containing your results from godgiftsyou@gmail.com. If you don't
          see an email from us within a couple of hours, please check your Spam folder.</p>
        <p>Let's get started!</p>
        <form onSubmit={this.handleSubmit}>
          <input type="text" placeholder="Enter your name" ref="name" />
          <br /><br />
          <input type="text" placeholder="Enter your email address (optional)" ref="email" />
          <br /><br />
          <input type="submit" value="Submit" />
        </form>
      </div>
    );
  }

  renderQuiz() {
    return (
      <Quiz
        answer={this.state.answer}
        answerOptions={this.state.answerOptions}
        questionId={this.state.questionId}
        question={this.state.question}
        questionTotal={quizQuestions.length}
        onAnswerSelected={this.handleAnswerSelected}
      />
    );
  }

  renderResult() {
    return (
      <Result quizResult={this.state.results} />
    );
  }

  renderPage() {
    if (this.state.name.length < 1) {
      return this.renderLogin();
    } else if (this.state.results.length > 0) {
      return this.renderResult();
    } else {
      return this.renderQuiz();
    }
  }

  render() {
    var content = this.renderPage();
    return (
      <div className="App">
        <div className="App-header">
          <img src={ggylogo} alt="logo" />
          <h2>Spiritual Gifts Assessment</h2>
        </div>
        {content}
      </div>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js